import { Skeleton } from "@mui/material";
import React from "react";

function FaqsSkeleton() {
  return <Skeleton variant="rectangular" width="100%" height={300} />;
}

export default FaqsSkeleton;
